export const FETCH_INFO_REQUEST = "FETCH_INFO_REQUEST";
export const FETCH_INFO_SUCCESS = "FETCH_INFO_SUCCESS";
export const FETCH_INFO_FAILURE = "FETCH_INFO_FAILURE";

export const CREATE_INFO_REQUEST = "CREATE_INFO_REQUEST";
export const CREATE_INFO_SUCCESS = "CREATE_INFO_SUCCESS";
export const CREATE_INFO_FAILURE = "CREATE_INFO_FAILURE";

export const UPDATE_INFO_REQUEST = "UPDATE_INFO_REQUEST";
export const UPDATE_INFO_SUCCESS = "UPDATE_INFO_SUCCESS";
export const UPDATE_INFO_FAILURE = "UPDATE_INFO_FAILURE";

export const DELETE_INFO_REQUEST = "DELETE_INFO_REQUEST";
export const DELETE_INFO_SUCCESS = "DELETE_INFO_SUCCESS";
export const DELETE_INFO_FAILURE = "DELETE_INFO_FAILURE";